import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import DepreciationsList from 'depreciations/components/list';

import { createRoute } from 'lib/util';
const { Form } = Common;

const DepreciationsListView = ({
  children,
  count = 0,
  filters = {},
  isLoading = false,
  company = {},
  pagination = {},
  permissions = {},
  subcompany = {},
  columnSearch,
  handleToggle = () => {}, ///////
  handleOrderChange = () => {},
  handleFiltersChange = () => {},
  handleLimitChange = () => {},
  handlePageChange = () => {},
  handleSubmit = () => {},
  handleToggleSearch = () => {}, // Agregar
  t,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      {/* <DepreciationsList.Header
        companyId={company.id}
        subcompanyId={subcompany.id}
        canAdd={permissions["acl.depreciations.add"]}
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={t('menu.configuration') + ' > ' + t('depreciations.depreciations_title')}
          icon={'calculator'}
          button={
            <div className="btn-group pull-right">
              {permissions['acl.depreciations.add'] && (
                <Form.Link
                  to={createRoute(company.id, subcompany.id, 'depreciations/add')}
                  className="btn btn-info mr-3"
                >
                  {t('actions.add')}
                </Form.Link>
              )}

              <DepreciationsList.Filters
                handleSubmit={handleSubmit}
                handleValueChange={handleFiltersChange}
                handleToggleSearch={handleToggleSearch}
                columnSearch={columnSearch}
                values={filters}
              />
            </div>
          }
        >
          <div className="mb-2" style={{ position: 'relative' }}>
            <DepreciationsList.Table
              company={company} ////////
              subcompany={subcompany} ///////////
              permissions={permissions} ///////
              handleToggle={handleToggle} //////////
              count={count}
              handleOrderChange={handleOrderChange}
              order={pagination.order}
              orderBy={pagination.orderBy}
            >
              {children}
            </DepreciationsList.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(DepreciationsListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/DepreciationsListView.js